import React from 'react';

import type { RedditPostComponentsProps } from './types';

export function Header(_props: RedditPostComponentsProps): React.JSX.Element {
	return <div>Reddit Group Post Header</div>;
}
